var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDocbayLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 184,
    height: 30,
    viewBox: "0 0 184 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0C5.37273 0 0 5.37273 0 12C0 18.6273 5.37273 24 12 24C18.6273 24 24 18.6273 24 12C24 5.37273 18.6273 0 12 0ZM18.9576 13.6276H14.4436C13.9936 13.6276 13.6276 13.9936 13.6276 14.4436V18.9576H10.3709V14.4436C10.3709 13.9936 10.005 13.6276 9.555 13.6276H5.04093V10.3709H9.555C10.005 10.3709 10.3709 10.005 10.3709 9.555V5.04094H13.6276V9.555C13.6276 10.005 13.9922 10.3709 14.4436 10.3709H18.9576V13.6276Z",
    fill: "#6BE4FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.55619 13.6302H5.04212V10.3735C0.807159 10.3735 0.502441 15.443 0.502441 15.443C2.98304 23.2393 10.3736 23.8915 10.3736 23.8915V14.4462C10.3736 13.9962 10.0076 13.6302 9.55761 13.6302H9.55619Z",
    fill: "url(#paint0_linear_2669_41896)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.55423 10.3712C10.0042 10.3712 10.3702 10.0052 10.3702 9.55522V5.04116H13.6269C13.6269 0.8062 8.55744 0.501465 8.55744 0.501465C0.76107 2.98206 0.108887 10.3726 0.108887 10.3726H9.55423V10.3712Z",
    fill: "url(#paint1_linear_2669_41896)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6328 0.108887V5.04018V9.55424C13.6328 10.0042 13.9973 10.3702 14.4487 10.3702H18.9628V13.6269C23.1978 13.6269 23.5025 8.55745 23.5025 8.55745C21.0219 0.761078 13.6313 0.108887 13.6313 0.108887H13.6328Z",
    fill: "url(#paint2_linear_2669_41896)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9553 13.6279H14.4413C13.9913 13.6279 13.6253 13.9939 13.6253 14.4438V18.9579H10.3687C10.3687 23.1929 15.4381 23.4976 15.4381 23.4976C23.2344 21.017 23.8866 13.6265 23.8866 13.6265H18.9553V13.6279Z",
    fill: "url(#paint3_linear_2669_41896)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 0H39.982C46.3607 0 51.2572 4.34493 51.2572 12.0687C51.2572 19.7926 46.3607 24.1375 39.982 24.1375H31.5V0ZM39.982 22.5856C45.1548 22.5856 49.3262 19.0001 49.3262 12.0687C49.3262 5.13741 45.1537 1.5861 39.982 1.55184H33.2928V22.5856H39.982Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M53.7383 14.6552C53.7383 8.44901 57.8411 4.8623 62.91 4.8623C67.9789 4.8623 72.0818 8.44787 72.0818 14.6552C72.0818 20.8626 67.9789 24.4482 62.91 24.4482C57.8411 24.4482 53.7383 20.8626 53.7383 14.6552ZM70.2547 14.6552C70.2547 9.41392 67.0483 6.37989 62.91 6.34563C58.7718 6.31138 55.5653 9.41392 55.5653 14.6552C55.5653 19.8966 58.7718 23.0003 62.91 22.966C67.0483 22.9306 70.2547 19.8966 70.2547 14.6552Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M74.5977 14.621C74.5977 8.86238 78.0108 4.8623 83.7694 4.8623C89.0107 4.8623 91.8723 8.27658 92.2868 12.4137H90.4598C90.2188 9.17298 87.8734 6.34449 83.7705 6.34449C79.2189 6.34449 76.4258 9.75877 76.4258 14.6198C76.4258 19.7573 79.6323 22.9649 83.7705 22.9649C87.9088 22.9649 90.0807 19.8269 90.4598 17.2748H92.2868C91.8038 21.0339 88.8383 24.447 83.7694 24.447C78.2871 24.447 74.5977 20.5509 74.5977 14.6198V14.621Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M117.648 17.3443C117.648 21.5853 114.063 24.1375 109.648 24.1375H99.7866V0H109.235C112.786 0 115.924 2.24155 115.924 6.17197C115.924 8.65447 114.338 10.4815 111.994 11.2409C115.304 11.8621 117.648 13.9997 117.648 17.3443ZM101.579 1.55184V10.6208H108.441C111.751 10.6208 113.993 8.9662 113.993 6.17311C113.993 3.38003 111.89 1.55184 108.82 1.55184H101.579ZM115.717 17.3443C115.717 14.1379 113.097 12.1715 109.131 12.1715H101.579V22.5857H109.269C112.958 22.5857 115.717 20.3784 115.717 17.3443Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M138.059 22.6879V24.1358H136.749C134.991 24.1358 133.922 23.067 133.922 21.2388V19.1012C133.026 22.48 130.094 24.4795 126.577 24.4795C122.888 24.4795 120.267 22.3419 120.267 18.6866C120.267 15.3078 122.474 12.9634 127.129 12.9634H129.611C132.611 12.9634 133.714 12.0671 133.714 10.377C133.714 7.86029 131.645 6.34271 128.611 6.34271C125.369 6.34271 123.093 8.06697 122.784 11.3077H120.991C121.336 7.16944 124.233 4.85938 128.612 4.85938C132.991 4.85938 135.543 7.2391 135.543 10.7562V21.0321C135.543 22.1009 135.992 22.6867 136.991 22.6867H138.06L138.059 22.6879ZM133.818 12.3776H133.784C133.301 13.7217 131.921 14.481 129.439 14.481H127.197C123.439 14.481 122.128 16.6541 122.128 18.6878C122.128 20.8608 123.542 22.9642 126.818 22.9642C130.267 22.9642 133.818 20.6541 133.818 15.3089V12.3776Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M153.647 5.17285L144.337 29.0351C144.096 29.6209 143.543 30 142.785 30H136.888V28.5521H142.75L144.887 23.1041L137.783 5.17399H139.68L145.749 21.1389L151.749 5.17399H153.646L153.647 5.17285Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M169.073 3.08998C169.073 5.0335 167.574 6.13543 165.661 6.13543H161.943V10.711H161.147V0H165.661C167.574 0 169.073 1.14761 169.073 3.09113V3.08998ZM168.216 3.08998C168.216 1.63634 167.145 0.687423 165.493 0.687423H161.943V5.44572H165.493C167.145 5.44572 168.216 4.55847 168.216 3.08998Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M170.432 2.28954H171.166V4.09488H171.197C171.503 3.08544 172.268 2.15137 173.798 2.15137H174.824V2.82509H173.615C172.146 2.82509 171.197 3.91103 171.197 5.96075V10.7042H170.432V2.28839V2.28954Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M174.87 6.49744C174.87 3.74318 176.691 2.15137 178.939 2.15137C181.188 2.15137 183.009 3.74318 183.009 6.49744C183.009 9.2517 181.188 10.8424 178.939 10.8424C176.691 10.8424 174.87 9.25056 174.87 6.49744ZM182.199 6.49744C182.199 4.17139 180.777 2.82509 178.941 2.8091C177.104 2.79425 175.682 4.17139 175.682 6.49744C175.682 8.82349 177.104 10.2006 178.941 10.1846C180.777 10.1698 182.199 8.82235 182.199 6.49744Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2669_41896",
    x1: 5.438,
    y1: 10.3735,
    x2: 5.438,
    y2: 23.8915,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#0989A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#2FBAD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#6BE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6BE4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2669_41896",
    x1: 13.6269,
    y1: 5.4356,
    x2: 0.108887,
    y2: 5.4356,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#0989A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#2FBAD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#6BE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6BE4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2669_41896",
    x1: 18.5683,
    y1: 13.6269,
    x2: 18.5683,
    y2: 0.108887,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#0989A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#2FBAD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#6BE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6BE4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2669_41896",
    x1: 10.3687,
    y1: 18.5635,
    x2: 23.8866,
    y2: 18.5635,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#0989A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.317708,
    stopColor: "#2FBAD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#6BE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6BE4FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocbayLogo);
export default __webpack_public_path__ + "static/media/docbay-logo.62f1bb2c0d6389d5d734ccb09b5aff7d.svg";
export { ForwardRef as ReactComponent };